import { h, Component } from 'preact';

export default class ChatFrame extends Component {

    // Allow Preact to re-render this component ONLY when isMobile changes.
    // The DOM diff will produce zero changes (src is identical), but
    // componentDidUpdate will fire so we can relay the flag via postMessage.
    shouldComponentUpdate(nextProps) {
        return nextProps.isMobile !== this.props.isMobile;
    }

    // ── postMessage helpers ────────────────────────────────────────────

    sendMobileFlag(isMobile) {
        try {
            if (this.iframe && this.iframe.contentWindow) {
                this.iframe.contentWindow.postMessage(
                    { event: 'toggle-mobile', isMobile },
                    '*'
                );
            }
        } catch (e) {
            // cross-origin guard (shouldn't happen in same-domain setup)
        }
    }

    componentDidMount() {
        if (!this.iframe) return;

        // iframe may already be loaded from cache — check readyState first
        const send = () => this.sendMobileFlag(this.props.isMobile);
        if (
            this.iframe.contentDocument &&
            this.iframe.contentDocument.readyState === 'complete'
        ) {
            send();
        } else {
            this.iframe.addEventListener('load', send, { once: true });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isMobile !== this.props.isMobile) {
            this.sendMobileFlag(this.props.isMobile);
        }
    }

    // ── Render ─────────────────────────────────────────────────────────

    render({ intergramId, host, iFrameSrc, conf }) {
        const dynamicConf  = window.intergramOnOpen || {};
        const encodedConf  = encodeURIComponent(JSON.stringify({ ...conf, ...dynamicConf }));

        return (
            <iframe
                ref={(el) => { this.iframe = el; }}
                src={`${iFrameSrc}?id=${intergramId}&host=${host}&conf=${encodedConf}`}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block',
                    // Prevent pull-to-refresh from interfering on mobile
                    overscrollBehavior: 'contain'
                }}
                frameborder="0"
                scrolling="no"
                allowtransparency="true"
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/widget/chat-frame.js